import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";
import {CompetitorPageMetaDataModel} from "../../../models/competitor-page.meta-data.model";
import {NEW_COMPETITOR_CONTAINER} from "../../../../competitor-container/competitor-container.consts";

export class CompetitorStandingsPageRouteMetaDataModel extends CompetitorPageMetaDataModel {

  @computed get isBrackets() {
    return this.websiteModuleState.currentLinkModel?.hashParams?.brackets === NEW_COMPETITOR_CONTAINER.FILTERS.brackets;
  }

  @computed get page() {
    return this.isBrackets ? METADATA_FILTERS.COMPETITOR.bracket : METADATA_FILTERS.COMPETITOR.standings;
  }

  @computed get pageTitle() {
    let title = this.isBrackets ? this.bracketsStaticTitle : this.standingsStaticTitle;

    if (this.titleSection && this.titleSection.getElementValue(this.page)) {
      title = this.titleSection.getElementValue(this.page)
    }

    return title
  }

  @computed get description(): String {
    let description = this.isBrackets ? this.bracketsStaticDescription : this.standingsStaticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(this.page)
    }

    return description
  }

  get standingsStaticTitle() {
    return this.titleFormatTerm(this.websiteTerms.COMPETITOR_STANDINGS_TITLE_TEMPLATE)
  }

  get standingsStaticDescription() {
    return this.descriptionFormatTerm(this.websiteTerms.COMPETITOR_STANDING_DESCRIPTION_TEMPLATE);
  }

  get bracketsStaticTitle() {
    return this.competitorName + ' Brackets page'
  }

  get bracketsStaticDescription() {
    return this.descriptionFormatTerm(this.websiteTerms.COMPETITOR_BRACKET_DESCRIPTION);
  }
}